import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import * as _ from "lodash";
import {CommonConstants} from "../../../../shared/constants/common-constants.enum";
import {API} from "../../../../shared/apis/api";
import {UrlType} from "../../../../shared/constants/url-type.enum";
import {BodyContentModel} from "../../../../shared/model/body-content-model";
import {ActionBarType} from "../../../../shared/constants/action-bar-type.enum";
import {MeterSampleLabels} from "../../../../shared/constants/meter-sample.enum";
import {HeaderInfo} from "../../../../shared/model/header-info";
import {ActionBarConfig} from "../../../../shared/model/action-bar-config";
import {Cooperative} from "../../../../shared/model/cooperative";
import {HttpCustomService} from "../../../../service/http-custom.service";
import {Subject, Subscription} from "rxjs/Rx";
import {takeUntil} from "rxjs/operators";
import {CustomerAddComponent} from "../customer-add/customer-add.component";
import {ImportCustomerComponent} from "../../../../shared/compoment/import-customer/import-customer.component";
import {CloseMeterDataComponent} from "../../../../shared/compoment/close-meter-data/close-meter-data.component";
import {Station} from "../../../../shared/model/station";

@Component({
  selector: 'omni-customer-list',
  templateUrl: './customer-list.component.html',
  styleUrls: ['./customer-list.component.scss']
})
export class CustomerListComponent implements OnInit, OnDestroy {

  bodyContent: BodyContentModel;
  cooperativeNo: string;
  actionBarConfig: ActionBarConfig;
  refresh = false;
  headerInfo: HeaderInfo;
  ngUnsubscribe: Subject<any> = new Subject();
  subscriptions: Subscription[] = [];
  subscriptionsParams: Subscription[] = [];
  stationNo: string;
  station: Station;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private http: HttpCustomService
  ) {
  }

  ngOnInit(): void {
    this.initActionBarConfig();
    this.subscriptionsParams.push(
      this.route.params.subscribe(routeParams => {
        this.stationNo = routeParams.stationNo;
        this.cooperativeNo = routeParams.cooperativeNo;
        this.getStationInfo();
      })
    );
  }

  initHeaderInfo(): void {
    this.headerInfo = new HeaderInfo();
    this.headerInfo.statusCode = this.station.statusCode;
    this.headerInfo.title = 'Thông tin Trạm';
    this.headerInfo.name = `Mã Trạm: ${this.station.stationCode} --- Tên Trạm: ${this.station.stationName} --- Ngày kết thúc: ${this.station.effectiveEndDate || ''}`;
  }

  private initActionBarConfig(): void {
    this.actionBarConfig = {
      buttonBarConfigs: [
        {actionBarType: ActionBarType.REFRESH},
        {actionBarType: ActionBarType.CLOSE, customAction: true}
      ]
    };
  }

  refreshAll(): void {
    this.getStationInfo();
    this.refresh = !this.refresh;
  }

  unsubscribe(): void {
    _.forEach(this.subscriptions, sub => {
      sub.unsubscribe();
    });
    this.subscriptions = [];
  }

  unsubscribeSubParams(): void {
    _.forEach(this.subscriptionsParams, sub => {
      sub.unsubscribe();
    });
    this.subscriptionsParams = [];
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
    this.unsubscribe();
    this.unsubscribeSubParams();
  }

  private buildBodyContent() {
    const params = {};
    if (!_.isNil(this.stationNo)) {
      _.assign(params, {'station-no': this.stationNo});
    }
    const urlTypes = {
      [UrlType.DELETE]: {path: API.CUSTOMER_DELETE}
    }
    this.bodyContent = {
      header: {
        title: 'Danh sách KH'
      },
      searchArea: {
        box: true,
        placeholder: 'Tìm kiếm KH'
      },
      tableConfig: {
        rowId: 'customerNo',
        columnNameRouter: 'customerNo',
        enableLink: true,
        enableCheckbox: true,
        columnData: CustomerListComponent.buildCustomerColumns(),
        urlStateParam: {path: API.CUSTOMER_SEARCH},
        customParams: params,
        editUrl: `/meter-cooperative/cooperative/${this.cooperativeNo}/station/${this.station.stationNo}/customer/:routerId`
      },
      subActionBars: {
        urlType: urlTypes,
        addNewForm: CustomerAddComponent,
        uploadForm: ImportCustomerComponent,
        closingMeterDataForm: CloseMeterDataComponent,
        initState: {
          stationNo: this.station.stationNo,
          stationName: this.station.stationName,
          cooperativeNo: this.cooperativeNo
        },
        buttonBarConfigs: [
          {actionBarType: ActionBarType.CLOSING_METER_DATA},
          {actionBarType: ActionBarType.NEW, customLabel: CommonConstants.ADD_NEW_CUSTOMER_LABEL},
          {actionBarType: ActionBarType.UPLOAD, customLabel: CommonConstants.IMPORT_CUSTOMER_LABEL},
          {actionBarType: ActionBarType.DELETE},
        ],
        id: 'customer-list',
        deleteMessageNoRef: true
      }
    }
  }

  private static buildCustomerColumns() {
    return [
      {
        name: 'Tên KH',
        data: 'customerName',
        type: 'link'
      },
      {
        name: 'Mã KH',
        data: 'customerCode'
      },
      {
        name: 'Mã điểm đo',
        data: 'measuringPointCode',
      },
      {
        name: 'Mã công tơ',
        data: 'meterCode'
      },
      {
        name: 'Kiểu công tơ',
        data: 'meterSample',
        enumType: MeterSampleLabels
      },
      {
        name: 'Tên đăng nhập',
        data: 'userName',
        orderable: false
      },
      {
        name: 'Mật khẩu',
        data: 'rawPassword',
        type: 'password',
        orderable: false
      },
      {
        type: 'edit',
        editComponent: CustomerAddComponent,
        initStateObject: 'customer',
        orderable: false
      }
    ];
  }

  private getStationInfo() {
    const url = {
      path: API.STATION_DETAIL,
      bind: {
        stationNo: {
          name: 'stationNo',
          placeholder: ':stationNo'
        }
      },
      values: {stationNo: this.stationNo}
    };
    this.http.get(url).pipe(takeUntil(this.ngUnsubscribe)).subscribe(res => {
      if (res) {
        this.station = res;
        this.initHeaderInfo();
        this.buildBodyContent();
        this.refresh = !this.refresh;
      }
    }, error => {
      this.router.navigate(['/meter-cooperative/home']).finally();
    })
  }

  close() {
    this.router.navigate([`/meter-cooperative/cooperative/${this.cooperativeNo}`]).finally();
  }
}
